import React, { useEffect, useState } from "react"
import {
  Button,
  Checkbox,
  Col,
  Form,
  Input,
  message,
  Modal,
  notification,
  Radio,
  Row,
  Select,
  Space,
  Table,
} from "antd"
import { useDispatch, useSelector } from "react-redux"
import { RootDispatch } from "../../app/store"
import { CloseOutlined, PlusOutlined, SearchOutlined } from "@ant-design/icons"
import styles from "./drinkingWater.module.css"
import axios from "axios"
import { selectCredentials, selectTenantName } from "../../app/applicationSlice"
import moment from "moment"
import {
  DateTimeFormatSimples,
} from "../../models/datetime"
import { PreviewImgOrPdf } from "../filingManagement/Preview"
import { AXIOS_IP_WATER } from "../filingManagement/fileUploadService"
import { MemberModal } from "./MemberModal"
import { WateTyperInfoModal } from "./WateTyperInfoModal"
import { getWaterTypeName } from "./drinkWater"

export const MainModal = (props: {
  visible: boolean
  isCreate: boolean
  token: string
  againId?: string
  onOk: () => void
  onCancel: () => void
}) => {
  const dispatch = useDispatch<RootDispatch>()

  const credentials: any = useSelector(selectCredentials)

  const [form] = Form.useForm()

  //人员
  const [memberVisible, setMemberVisible] = useState(false)
  const [memberlist, setMemberlist] = useState<any>([])

  const [confirmLoading, setConfirmLoading] = useState(false)

  const [previewFile, setPreviewFile] = useState<any>() //预览

  const inputRef = React.useRef<any>(null)

  const [checkedData, setCheckedData] = useState<any>([]) //选中数据

  const [id, setId] = useState<any>() // 完善信息表单id

  const [memberId, setMemberId] = useState<any>() // 人员id

  const [waterType, setWaterType] = useState(0)

  const lableAlign = { labelCol: { span: 8 }, wrapperCol: { span: 16 } }

  //参考模板
  const templateData = {
    fileConfigId: "5",
    fileName: "参考模板",
    fileType: "application/pdf",
    filePath:
      "68e0cfd54adf77575a83a2b739bf5ddfa207356d866e9e74b8236c4b070475f8",
  }

  useEffect(() => {
    form.setFieldsValue({
      staffHealthCertId: memberlist?.map((n: any) => n.id),
    })
  }, [memberlist])

  useEffect(() => {
    if (!props.visible) {
      form.resetFields()
      setMemberlist([])
      setCheckedData([])
    } else {
      if(props?.againId) {
        axios({
          url: `${AXIOS_IP_WATER}/drinkingWater/detailPage`,
          headers: {
            "Content-Type": "application/json",
            "His-Auth": props.token,
          },
          withCredentials: false,
          method: "POST",
          data: { id: props.againId },
        }).then((res) => {
          const m = res.data.data
          const catrgoryList = m.category?.split(',')?.map((item: string) => Number(item))
          form.setFieldsValue({
            ...res.data.data,
            waterHealthId: catrgoryList,
            category: catrgoryList,
          })
          setCheckedData(m.waterHealthList?.map((w: any) => {
            return {
              id: w.id,
              category: w.category,
            }
          }))
          setMemberlist(m.staffHealthCertList)
        })
      }
    }
  }, [props.visible, inputRef])

  return (
    <>
      <Modal
        title="饮用水申报"
        width={1000}
        visible={props?.visible}
        confirmLoading={confirmLoading}
        onCancel={() => {
          props?.onCancel()
        }}
        onOk={form.submit}
        okText="提交"
        centered
        maskClosable={false}
      >
        <div style={{ height: 600, overflow: "auto" }}>
          <Form
            form={form}
            labelCol={{ span: 4 }}
            wrapperCol={{ span: 20 }}
            style={{ paddingRight: 10 }}
            onFinish={(vs) => {
              if (!memberlist.length) {
                message.error("请添加管水人员健康证")
                return
              }
              const unWriteData = checkedData?.filter((c: any) => !c.id)?.map((d: any) => getWaterTypeName(d.category))
              if(unWriteData?.length) {
                message.error(`请完善${unWriteData.join(",")}的信息`)
                return
              }
              setConfirmLoading(true)
              axios({
                url: `${AXIOS_IP_WATER}/drinkingWater/saveOrUpdate`,
                headers: {
                  "Content-Type": "application/json",
                  "His-Auth": props.token,
                },
                withCredentials: false,
                method: "POST",
                data: {
                  id: props.isCreate ? null : props.againId,
                  ...vs,
                  waterHealthId: checkedData?.map((m: any) => m.id),
                  applicantUserId: credentials.userId,
                  applicantUserName: credentials.userName
                },
              }).then(() => {
                notification.success({
                  message: "保存成功",
                })
                props?.onOk()
              }).finally(() => {
                setConfirmLoading(false)
              })
            }}
          >
            <Row
              style={{
                fontWeight: "bold",
                borderBottom: "1px dashed #ccc",
                paddingBottom: 10,
                marginBottom: 10,
              }}
            >
              基本信息
            </Row>
            <Row>
              <Col span={24}>
                <Form.Item
                  name="rawSource"
                  label="原水来源"
                  rules={[{ required: true, message: "请选择原水来源" }]}
                >
                  <Radio.Group>
                    <Radio value={1}>市政供水</Radio>
                    <Radio value={2}>二次供水</Radio>
                    <Radio value={3}>分散式供水</Radio>
                    <Radio value={4}>自建供水</Radio>
                  </Radio.Group>
                </Form.Item>
              </Col>
            </Row>
            <Row className={styles.selfFormLabel}>
              <Col span={24}>
                <Form.Item
                  name="category"
                  label="饮用类别"
                  rules={[{ required: true, message: "请选择饮用类别" }]}
                >
                  <Checkbox.Group
                    onChange={(v) => {
                      form.setFieldsValue({
                        waterHealthId: v,
                      })
                      const newCheckData = v?.map((item) => {
                        const hasData = checkedData?.find((f: any) => f.category == item)
                        if(hasData?.category) {
                          return hasData
                        } else {
                          return { category: item, id: '' } 
                        }
                      })
                      newCheckData.sort((a, b) => a.category - b.category)
                      setCheckedData(newCheckData)
                    }}
                  >
                    <Row>
                      <Col span={8}><Checkbox value={1}>管道分质直饮水</Checkbox></Col>
                      <Col span={8}><Checkbox value={2}>净水器</Checkbox></Col>
                      <Col span={8}><Checkbox value={3}>桶装水（含九年一贯制）</Checkbox></Col>
                      <Col span={8}><Checkbox value={4}>开水炉/茶水桶</Checkbox></Col>
                      <Col span={8}><Checkbox value={5}>自建供水设施 </Checkbox></Col>
                      <Col span={8}><Checkbox value={6}>二次供水设施</Checkbox></Col>
                    </Row>
                  </Checkbox.Group>
                </Form.Item>
              </Col>
            </Row>
            <Row>
              <Col span={12}>
                <Form.Item
                  name="divisionLeaderName"
                  label="分管领导姓名"
                  {...lableAlign}
                  rules={[{ required: true }]}
                >
                  <Input allowClear />
                </Form.Item>
              </Col>
              <Col span={12}>
                <Form.Item
                  name="divisionLeaderPhone"
                  label="联系电话"
                  {...lableAlign}
                  rules={[
                    {
                      required: true,
                    },
                    {
                      pattern: new RegExp(
                        /^\d{3}-\d{8}|\d{4}-\d{7}|^(1[3,4,5,6,7,8,9][0-9]{9})$/
                      ),
                      message: '请输入正确的联系电话',
                    },
                  ]}
                >
                  <Input allowClear />
                </Form.Item>
              </Col>
              <Col span={12}>
                <Form.Item
                  name="providerUnit"
                  label="饮水机提供单位"
                  {...lableAlign}
                  rules={[{ required: true }]}
                >
                  <Input allowClear />
                </Form.Item>
              </Col>
              <Col span={12}>
                <Form.Item
                  name="maintenanceUnit"
                  label="维保单位"
                  {...lableAlign}
                  rules={[{ required: true }]}
                >
                  <Input allowClear />
                </Form.Item>
              </Col>
              <Col span={12}>
                <Form.Item
                  name="hygieneManagerName"
                  label="饮水卫生管理员姓名"
                  {...lableAlign}
                  rules={[{ required: true }]}
                >
                  <Input allowClear />
                </Form.Item>
              </Col>
              <Col span={12}>
                <Form.Item
                  name="hygieneManagerPhone"
                  label="饮水卫生管理员电话"
                  {...lableAlign}
                  rules={[{ required: true }]}
                >
                  <Input allowClear />
                </Form.Item>
              </Col>
            </Row>
            <Row className={styles.selfTable}>
              <Col span={24}>
                <Form.Item
                  label="管水人员健康证"
                  name="staffHealthCertId"
                  rules={[{ required: true, message: "请添加管水人员健康证" }]}
                >
                  <Button
                    type="primary"
                    icon={<PlusOutlined />}
                    onClick={() => {
                      setMemberId('')
                      setMemberVisible(true)
                    }}
                  >
                    添加
                  </Button>
                  <Table
                    dataSource={memberlist}
                    className={styles.QATable}
                    columns={[
                      {
                        title: "人员姓名",
                        align: "center",
                        width: "8rem",
                        ellipsis: true,
                        dataIndex: "staffName",
                      },
                      {
                        title: "健康证有效日期",
                        align: "center",
                        width: "10rem",
                        ellipsis: true,
                        dataIndex: "healthCertExpiryDate",
                        render: (_, t: any) => {
                          return moment(t.healthCertExpiryDate).format(DateTimeFormatSimples)
                        },
                      },
                      {
                        title: "健康证",
                        align: "center",
                        width: "8rem",
                        ellipsis: true,
                        render: function Element(_, m: any) {
                          return (
                            <Space>
                              <Button
                                type="link"
                                onClick={() => {
                                  setPreviewFile(m.healthCertUrl?.[0])
                                }}
                              >
                                查看
                              </Button>
                            </Space>
                          )
                        },
                      },
                      {
                        title: "操作",
                        align: "center",
                        width: "8rem",
                        ellipsis: true,
                        render: function Element(_, m) {
                          return (
                            <Space>
                              <Button
                                type="link"
                                danger
                                onClick={() => {
                                  setMemberlist(
                                    memberlist?.filter(
                                      (v: any) => v.id !== m.id
                                    )
                                  )
                                }}
                              >
                                删除
                              </Button>
                              <Button
                                type="link"
                                onClick={() => {
                                  setMemberId(m.id)
                                  setMemberVisible(true)
                                }}
                              >
                                编辑
                              </Button>
                            </Space>
                          )
                        },
                      },
                    ]}
                    rowKey={(t: any) => t.idCardNumber}
                    pagination={false}
                    style={{
                      marginTop: "13px",
                    }}
                  />
                </Form.Item>
              </Col>
            </Row>
            {checkedData?.length ? (
              <Row
                style={{
                  fontWeight: "bold",
                  borderBottom: "1px dashed #ccc",
                  paddingBottom: 10,
                  marginBottom: 20,
                }}
              >
                饮用水卫生健康档案
              </Row>
            ) : (
              <></>
            )}
            <Row>
              {checkedData?.map((v: any) => {
                return (
                  <Col span={24} key={v.category}>
                    <Form.Item
                      name="waterHealthId"
                      label={getWaterTypeName(v.category)}
                      rules={[ { required: true }]}
                    >
                      <Button 
                        type="primary" 
                        onClick={() => {
                          setId(v.id)
                          setWaterType(v.category)
                        }}
                      >
                        完善信息
                      </Button>
                    </Form.Item>
                  </Col>
                )
              })}
            </Row>
          </Form>
        </div>
      </Modal>

      <MemberModal
        visible={memberVisible}
        token={props.token}
        id={memberId}
        onOk={(v) => {
          if (v.lastId) {
            const newData = memberlist.map((m: any) => {
                if (m.id === v.lastId) {
                  return { ...v, lastId: undefined }
                }
                return m
              })
            setMemberlist(newData)
          } else {
            setMemberlist([...memberlist, v])
          }
          setMemberVisible(false)
        }}
        onCancel={() => setMemberVisible(false)}
      />

      <WateTyperInfoModal
        visible={waterType > 0}
        token={props.token}
        id={id}
        waterType={waterType}
        onOk={(data) => {
          setCheckedData(
            checkedData.map((v: any) => {
              if (v.category === data.category) {
                return data
              }
              return v
            })
          )
          setWaterType(0)
        }}
        onCancel={() => setWaterType(0)}
      />

      <PreviewImgOrPdf
        token={props.token}
        AXIOS_IP={AXIOS_IP_WATER}
        file={previewFile}
        onClose={() => setPreviewFile(null)}
      />
    </>
  )
}
